import { z } from 'zod';

export const contractDemandRequestItemSchema = z
  .object({
    baselinePricePerPriceUnit: z.coerce.number(),
    commodityGroupId: z.uuid(),
    commodityId: z.uuid(),
    description: z.string().nullish(),
    minimumOrderQuantity: z.coerce.number(),
    organizationId: z.uuid(),
    priceUnit: z.coerce.number(),
    quantity: z.coerce.number(),
    title: z.string(),
    unitId: z.uuid(),
    qualifiedSuppliers: z.array(z.uuid()),
    totalValue: z.coerce.number().optional(), // computed field
  })
  .refine((data) => data.quantity >= data.minimumOrderQuantity, {
    path: ['quantity'],
    params: { i18n: 'modules:ContractDemandRequestItemForm.quantity.error' },
  });

export type ContractDemandRequestItem = z.infer<typeof contractDemandRequestItemSchema>;
